export function normalizeCity(city) {
  return city?.split('-')[0];
}

export function getNumberFromAddress(address) {
  const numbers = address.match(/\d+/);
  return numbers ? numbers[0] : '';
}
